import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/martina/Desktop/Bigbang/web/app/[locale]/albums/[slug]/BookAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/martina/Desktop/Bigbang/web/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
